export default __webpack_public_path__ + "static/not-found-bg-a95deb8a99c44650acc987ad243e4181.svg";